export enum LayoutTypes {
  BARE,
  INSTITUTIONAL,
  DASHBOARD,
  DASHBOARD_NEW,
}
